module.exports = __webpack_public_path__ + "static/bens-040310f37bd1a2d6eec433e3953eca9d.png";